<template>
  <div class="guide-bg">
    <Steps
      v-if="step1"
      :title="$t('edit.guide.gapTimeMob')"
      :isShowArrow="true"
      @clickBack="onClickPreTo(-1)"
      @onClickNext="onClickNextTo(2)"
    >
      <template slot="body">
        <div class="body-input">
          <a-input-number id="inputNumber" v-model="gapTime" :min="1" :max="50" @change="onChange" />
        </div>
      </template>
    </Steps>

    <Steps
      v-if="step2"
      :title="$t('edit.guide.audioGuide')"
      :isShowArrow="true"
      displayType
      @clickBack="onClickPreTo(1)"
      @onClickNext="onClickNextTo(3)"
    >
      <template slot="body">
        <HListWithBtn :type="2" :rightButtonTile="$t('edit.hpInfo.audioSelect')" @selectChange="onSelectChange">
          <template slot="body">
            <div class="imge-item" v-if="currentAudio.url">
              <audio preload="none" controls="controls" :src="currentAudio.url" />
            </div>
          </template>
        </HListWithBtn>
      </template>
    </Steps>

    <Steps
      v-if="step3"
      :title="$t('edit.guide.textGuide')"
      :isShowArrow="true"
      :isLast="true"
      displayType
      @clickBack="onClickPreTo(2)"
      @onClickFinish="onClickFinish"
    >
      <template slot="body">
        <a-textarea :placeholder="$t('common.inputContent')" :rows="2" v-model="contentStr" />
      </template>
    </Steps>
  </div>
</template>

<script>
import Steps from "../../Steps.vue";
import HListWithBtn from "../../HListWithBtn.vue";


export default {
  components: { Steps, HListWithBtn },
  props: {
    targetObj: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      step1: true,
      step2: false,
      step3: false,
      gapTime: "",
      contentStr: "",
      currentAudio: {},
    };
  },
  watch: {
    targetObj: {
      handler: function () {
        if (this.targetObj) {
          this.handleDefault();
        }
      },
      immediate: true,
    },
  },
  methods: {
    onChange(value) {
      this.gapTime = value;
    },
    onClickFinish() {
      const data = this.targetObj;
      data.move_time = this.gapTime;
      data.content = this.contentStr;
      data.music_url = this.currentAudio.url ? this.currentAudio.url  : "";
      data.music_title = this.currentAudio.name ? this.currentAudio.name : "";
      this.$emit("saveChangeData", data);
    },
    onClickPreTo(value) {
      if (value === -1) {
        this.$emit("onClickBack");
      } else if (value === 1) {
        this.step1 = true;
        this.step2 = false;
        this.step3 = false;
      } else if (value === 2) {
        this.step1 = false;
        this.step2 = true;
        this.step3 = false;
      }
    },
    onClickNextTo(value) {
      if (value === 2) {
        // if (!this.audioObj.icon_url) {
        //   this.$message.error("請選擇熱點圖標");
        //   return;
        // }
        this.step1 = false;
        this.step2 = true;
        this.step3 = false;
      } else if (value === 3) {
        // if (!this.audioObj.title) {
        //   this.$message.error("請輸入熱點標題");
        //   return;
        // }
        this.step1 = false;
        this.step2 = false;
        this.step3 = true;
      }
    },
    onSelectChange(value) {
      this.currentAudio = { name: value.name, url: value.url };
    },
    handleDefault() {
      this.gapTime = this.targetObj.move_time;
      this.contentStr = this.targetObj.content;
      this.currentAudio.url = this.targetObj.music_url;
      this.currentAudio.name = this.targetObj.music_title;
    },
    
  },
};
</script>

<style lang="less" scoped>
.guide-bg {
  // padding: 5px 10px;
  .imge-item {
    width: 100px;
    height: 47px;
    margin-right: 5px;
    audio {
      width: 200px;
      height: 40px;
    }
  }
  .body-input {
    text-align: center;
    margin: 0 auto;
  }
}
</style>